import apiUrl from '../../../../../constants';
import axios from 'axios';
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import { BasicSelect } from 'vue-search-select'
import DatePicker from 'vue2-datepicker'
import ClientService from './../../../services/clientmanagement.service';
import Loader from '../../../../shared/components/loader';
import Multiselect from 'vue-multiselect'

export default {
  name: 'saveClientContractAnnexure',
  props: ['CompanyShortNameArray'],
  components: {
    VueElementLoading,
    BasicSelect,
    DatePicker,
    Loader,
    Multiselect
  },
  data: function() {
    return {
      annexurename:'',
      annexuresdescription:'',
      CompanyShortList: [],
      contractIdList: [],
      companyName:'',
      userName:'',
      contractId:'',
      AnnexureFilePath:'',
      fileExtension:'',
      companyShortName:'',
      showTemplateFlag:false,
      isLoading:false,
      selectedcompanyName: null,
      selectedContractId: {
        "value": '',
        "text": ''
      }
    }
  },
  computed: {

  },
  mounted() {
    var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.userName = userdetail.email;
    this.getCompanyShortList();
  },
  methods: {
    getCompanyShortList(){
      this.CompanyShortList = this.CompanyShortNameArray;
    },
    showAnnexure() {
      this.$emit("goBackToParent")
    },
    async getContractList(){
      try {
        this.contractIdList = [];
        this.isLoading = true;
        let inputPayload = {
          clientid: this.companyName,
          clientbusinessaccountid : this.clientbusinessaccountid
        };
        let result = await ClientService.getClientContractDropdownList(inputPayload);
        let contractlist = result.data.data;
        for (var i = 0; i < contractlist.length; i++) {
          if(contractlist[i].contractstatus==0){
            this.contractIdList.push({
              'value': contractlist[i].id,
              'text': contractlist[i].contractidlabel
            });
          }
        }
        this.isLoading = false;
      } catch(err){
        console.log(err);
        this.isLoading = false;
      }
    },
    async onFileChangedForAnnexure(event){
      let uploadAnnexureFile = event.target.files[0];
      if(uploadAnnexureFile.size > 20971520){
        return this.$alert(`Please upload document less than 20MB.`,this.annexurename,"error");
      }
      if ( /\.(jpe?g|png|pdf)$/i.test(uploadAnnexureFile.name) ){
        this.isLoading = true;
        this.fileExtension = uploadAnnexureFile.name.split('.').pop().toLowerCase();
        let formData = new FormData();
        /*Add the form data we need to submit*/
        formData.append("file", uploadAnnexureFile);
        formData.append("annexure", true);
        formData.append("companyShortName", this.companyShortName);
        formData.append("fileName", uploadAnnexureFile.name);
        let result = await ClientService.uploadDocment(formData)
        this.isLoading = false;
        if (result.data.errorCode == 0) {
          this.$alert("Document Upload successfully.",this.annexurename,"success");
          this.AnnexureFilePath = result.data.data;
        } else {
          this.$alert("Please try again.",this.annexurename,"error");
          event.target.value = '';
          this.fileExtension = '';
        }
      }else {
        event.target.value = '';
        this.fileExtension = '';
        this.$alert("Please upload only allowed file format",this.annexurename,"error");
        return true;
      }
    },
    async saveClientContractAnnexure(){
      try {
        var inputPayload = {};
        this.isLoading = true;
        inputPayload.clientcontractid = this.contractId,
        inputPayload.annexurename = this.annexurename,
        inputPayload.annexuredscription = this.annexuresdescription,
        inputPayload.annexureurl = this.AnnexureFilePath,
        inputPayload.createdby = this.userName
        let result = await ClientService.saveClientContractAnnexure(inputPayload);
        this.isLoading = false;
        if (result.data.code == 200) {
          this.$alert(result.data.message, this.annexurename, "success");
          this.$emit("goBackToParent");
        }else{
          this.$alert(result.data.message, this.annexurename, "error");
        }
      } catch(err){
        this.isLoading = false;
        console.log(err);
      }
    },
    selectCompanyName(data){
        this.selectedcompanyName = data;
        this.companyName = data.value;
        this.clientbusinessaccountid = data.ClientBusinessAccountId
        this.companyShortName = data.text;
        this.getContractList();
    },
    selectContractId(data){
        this.selectedContractId = data;
        this.contractId = data.value;
    },
    onSubmit: function(event) {
      this.$validator.validateAll().then((result) => {
        if(result){
          this.saveClientContractAnnexure(event);
        }
      }).catch(() => {
        console.log('errors exist', this.errors)
      });
    },
    fileview(index){
      var link = document.createElement('a');
      link.href = index;
      link.setAttribute('target','_blank');
      window.open(index, '_blank');
      link.remove();
      return true;
    },
  }
}



// WEBPACK FOOTER //
// ./src/modules/clientmanagement/views/ClientAnnexures/CreateClientAnnexures/CreateClientAnnexures.component.js